var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "ctm-address-preview" }, [
    _c(
      "div",
      { staticClass: "ctm-address-preview__grid" },
      [
        _vm._l(_vm.field.address, function(sub, key) {
          return [
            sub.checked
              ? _c(
                  "div",
                  {
                    key: key,
                    class: [
                      "ctm-address-preview__field",
                      "ctm-address-preview__field--" + key
                    ]
                  },
                  [
                    _c("label", { staticClass: "ctm-address-preview__label" }, [
                      _vm._v("\n          " + _vm._s(sub.label)),
                      sub.required
                        ? _c("span", { staticClass: "required" }, [
                            _vm._v(" *")
                          ])
                        : _vm._e()
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "ctm-address-preview__input" }, [
                      _vm._v(
                        "\n          " +
                          _vm._s(sub.placeholder || " ") +
                          "\n        "
                      )
                    ])
                  ]
                )
              : _vm._e()
          ]
        })
      ],
      2
    ),
    _vm._v(" "),
    _vm.field.help
      ? _c("span", {
          staticClass: "ctm-address-preview__help",
          domProps: { innerHTML: _vm._s(_vm.field.help) }
        })
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }